// src/pages/Jobs/JobMapPage.tsx - FIXED VERSION
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'reactstrap';
import Header from '../Home/Header';
import Footer from '../Home/Footer';
import SEOTags from '../Listing/SEOTags';
import AutoBreadCrumb from '../../Components/Common/AutoBreadCrumb';
import InteractiveUSMap, { MapRegion } from '../../Components/InteractiveUSMap';

const JobMapPage: React.FC = () => {
    const navigate = useNavigate();

    const handleStateClick = (region: MapRegion) => {
        console.log('🔍 JobMapPage: State clicked:', region);

        if (region.state_code) {
            const statePath = `/jobs/${region.state_code.toLowerCase()}`;
            console.log('🔍 JobMapPage: Navigating to:', statePath);
            navigate(statePath);
        } else {
            console.warn('🔍 JobMapPage: No state code available for region:', region);
        }
    };

    return (
        <React.Fragment>
            <SEOTags
                title="Construction Project Opportunities Map | Find Jobs by Location"
                description="Interactive map showing construction projects across the United States. Click on any state to explore local job postings and project opportunities."
                keywords={['construction projects', 'construction job postings', 'jobs map', 'job opportunities', 'employment by state', 'interactive job search']}
                schemaType="WebPage"
            />

            <Header isFullWidth={true} />

            <div className="page-content">
                <Container fluid className="px-4">
                    <AutoBreadCrumb customTitle="Construction Projects Map" />

                    <div className="mb-4">
                        <h1 className="display-6 fw-semibold mb-3">
                            Explore Construction Projects by Location
                        </h1>
                        <p className="text-muted mb-0 fs-16">
                            Discover construction projects and job opportunities across the United States.
                            Click on any state to explore local construction project jobs in your area.
                        </p>
                    </div>

                    <InteractiveUSMap
                        level="country"
                        onRegionClick={handleStateClick}
                        height={600}
                        className="mb-4"
                    />
                </Container>
            </div>

            <Footer />
        </React.Fragment>
    );
};

export default JobMapPage;